import React from "react";
import { Checkbox, Form, Input, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

// Either DS user ID or DS user name is required
const createDSUserValidation = otherFieldName => [
  ({ getFieldValue }) => ({
    validator(_, value) {
      const otherValue = getFieldValue(otherFieldName);
      if (!value && !otherValue) {
        return Promise.reject(new Error("Either DS user ID or DS user name is required"));
      }
      return Promise.resolve();
    },
  }),
];

const CRMDrawerContent = ({ crmForm }) => (
  <Form form={crmForm} layout="vertical">
    <p className="text-black-88 font-semibold text-base mb-4">User mapping</p>

    <Form.Item name="active" valuePropName="checked">
      <Checkbox>
        <span className="form-field-label">Is DS user mapping active?</span>
      </Checkbox>
    </Form.Item>

    <div className="mb-4 flex items-start gap-1">
      <InfoCircleOutlined className="text-[#1890ff] text-sm mt-0.5" />
      <Text type="secondary" className="text-[13px] leading-normal">
        <strong>Note:</strong> If you provide only a DS username or DS user ID, we&apos;ll use that
        value for both. If you provide both, each value is preserved.
      </Text>
    </div>

    <Form.Item
      name="dsUserId"
      label={<span className="form-field-label">DS user ID</span>}
      dependencies={["dsUserName"]}
      rules={createDSUserValidation("dsUserName")}
    >
      <Input placeholder="Enter DS user ID" />
    </Form.Item>

    <Form.Item
      name="dsUserName"
      label={<span className="form-field-label">DS user name</span>}
      dependencies={["dsUserId"]}
      rules={createDSUserValidation("dsUserId")}
    >
      <Input placeholder="Enter DS user name" />
    </Form.Item>

    <p className="text-black-88 font-semibold text-base mt-6 mb-4">Call info</p>

    <Form.Item name="dmsId" label={<span className="form-field-label">DMS ID</span>}>
      <Input placeholder="Enter DMS ID" />
    </Form.Item>

    <Form.Item name="inboundId" label={<span className="form-field-label">Inbound ID</span>}>
      <Input placeholder="Enter Inbound ID" />
    </Form.Item>

    <Form.Item name="inboundId2" label={<span className="form-field-label">Inbound ID 2</span>}>
      <Input placeholder="Enter Inbound ID 2" />
    </Form.Item>

    <Form.Item name="outboundId" label={<span className="form-field-label">Outbound ID</span>}>
      <Input placeholder="Enter Outbound ID" />
    </Form.Item>
  </Form>
);

export default CRMDrawerContent;
